import React from 'react'
import { Route } from '../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { NodeCategoryEdit } from './page/node-category-edit'
import { NodeCategoryEditSys } from './page/node-category-edit-sys'
import { NodeCategoryMove } from './page/node-category-move'
import { NodeCategoryAdd } from './page/node-category-add'
import { NodeCategoryDelete } from './page/node-category-delete'
import { PermissionNode } from '../common/permission/permission-node'
import { NodeRecycle } from '../common/recycle/node-recycle'

export const NodeCategory = ({
  url,
  grandParentURL,
  nodeID,
  rootName,
  useApiListCategory,
  useApiFormCategory,
  useApiListRecycle,
  useApiFormRecycle,
  buildPathFn,
  dataContext,
  section
}) => {
  return (
    <React.Fragment>
      <Route path={`${url}/edit-sys`}>
        <NodeCategoryEditSys parentURL={url} nodeID={nodeID} useApiForm={useApiFormCategory} dataContext={dataContext} section={section} />
      </Route>

      <Route path={`${url}/add`}>
        <NodeCategoryAdd parentURL={url} parentID={nodeID} useApiForm={useApiFormCategory} dataContext={dataContext} />
      </Route>

      <Route path={`${url}/edit`}>
        <NodeCategoryEdit parentURL={url} nodeID={nodeID} useApiForm={useApiFormCategory} dataContext={dataContext} section={section} />
      </Route>

      <Route path={`${url}/move`}>
        <NodeCategoryMove
          parentURL={url}
          nodeID={nodeID}
          rootName={rootName}
          useApiListCategory={useApiListCategory}
          useApiForm={useApiFormCategory}
          buildPathFn={buildPathFn}
          dataContext={dataContext}
          section={section}
        />
      </Route>

      <Route path={`${url}/delete`}>
        <NodeCategoryDelete grandParentURL={grandParentURL} parentURL={url} nodeID={nodeID} useApiForm={useApiFormCategory} dataContext={dataContext} section={section} />
      </Route>

      <Route path={`${url}/recycle`}>
        <NodeRecycle nodeID={nodeID} useApiList={useApiListRecycle} useApiForm={useApiFormRecycle} dataContext={dataContext} />
      </Route>

      <PermissionNode url={url} nodeID={nodeID} />
    </React.Fragment>
  )
}
